<template>
  <ParentNode
    :id="id"
    :position="position"
    :elements="elements"
    :get-connected-elements="getConnectedElements"
    :get-connected-source-elements="getConnectedSourceElements"
    :events="events"
    :source-connection-active="sourceConnectionActive"
    :target-connection-active="targetConnectionActive"
    :add-new-node="addNewNode"
    :type="type"
    :data="data"
    :dimensions="dimensions"
    :new-node="newNode">
    <template #body>
      <div class="flex justify-center">
        <div v-if="data?.type == 'add'" class="h-full w-full">
          <AddNewItemsMenu
            :from-initial-add="!getConnectedSourceElements(id).length"
            :elements="elements"
            :type="type"
            :data="data"
            :get-connected-elements="getConnectedElements"
            :get-connected-source-elements="getConnectedSourceElements"
            class="w-6 h-6"
            @selectItem="handleSelectItem" />
        </div>

        <div
          v-else
          :style="{ width: `${dimensions.w}px`, height: `${dimensions.h}px` }"
          :class="{ 'bg-[#2a9568]': data.is_trigger_group_merge }"
          class="bg-[#2B3C44] p-0 text-white items-center text-center flex justify-center border rounded-full shadow-lg">
          <PlaybookMergeIcon
            v-if="data?.type == 'merge'"
            :class="[{ 'rotate-90': rotation == 'clockwise' }, { '-rotate-90': rotation == 'anti-clockwise' }]" />
          <PlaybookSplitIcon
            v-else-if="data?.type == 'split'"
            :class="[{ 'rotate-90': rotation == 'clockwise' }, { '-rotate-90': rotation == 'anti-clockwise' }]" />
        </div>
      </div>
    </template>
  </ParentNode>
</template>

<script>
import ParentNode from "./ParentNode.vue"
import AddNewItemsMenu from "./AddNewItemsMenu.vue"

import PlaybookMergeIcon from "@/components/shared/icons/PlaybookMergeIcon.vue"
import PlaybookSplitIcon from "@/components/shared/icons/PlaybookSplitIcon.vue"
export default {
  components: { ParentNode, PlaybookMergeIcon, PlaybookSplitIcon, AddNewItemsMenu },
  props: {
    id: null,
    position: null,
    data: null,
    type: null,
    dimensions: null,
    sourceConnectionActive: null,
    targetConnectionActive: null,
    events: null,
    getConnectedElements: null,
    getConnectedSourceElements: null,
    elements: null,
    addNewNode: null,
    newNode: null
  },
  emits: [],
  data() {
    return {}
  },
  computed: {
    rotation() {
      let rotation_calc = null
      if (this.data.type == "split") {
        const available_source_handles = []
        const source_connections = this.elements.filter((el) => el.source == this.id)
        source_connections.forEach((con) => {
          if (!available_source_handles.includes(con.sourceHandle)) {
            available_source_handles.push(con.sourceHandle)
          }
        })

        const connected_elements_to_split = this.getConnectedElements(this.id)
        if (available_source_handles.includes("t") && available_source_handles.includes("b")) {
          if (connected_elements_to_split[0]?.position.x > this.position?.x) {
            rotation_calc = "anti-clockwise"
          } else {
            rotation_calc = "clockwise"
          }
        }
      }

      if (this.data.type == "merge") {
        const available_target_handles = []
        const target_connections = this.elements.filter((el) => el.target == this.id)
        target_connections.forEach((con) => {
          if (!available_target_handles.includes(con.targetHandle)) {
            available_target_handles.push(con.targetHandle)
          }
        })

        const connected_elements_to_split = this.getConnectedSourceElements(this.id)
        if (available_target_handles.includes("t") && available_target_handles.includes("b")) {
          if (connected_elements_to_split[0]?.position.x > this.position?.x) {
            rotation_calc = "clockwise"
          } else {
            rotation_calc = "anti-clockwise"
          }
        }
      }
      return rotation_calc
    }
  },
  watch: {},

  created() {},

  methods: {
    handleSelectItem(item) {
      if (this.getConnectedSourceElements(this.id).length) {
        this.events.addNewItem({ ...item, node_id: this.id, position: "b" })
      } else {
        this.events.addNewItem(item)
      }
    }
  }
}
</script>
